import { Country } from '../types/company'

export const USA = 'United States of America'

export const isAmerica = (country?: Country) => country?.name === USA
